module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        code: {
            type: 'string'
        },
        default: {
            type: 'boolean'
        },
        description: {
            type: 'string'
        },
        cost: {
            type: 'number'
        },
        priceType: {
            type: 'string'
        },
        pickUpLocation: {
            type: 'string'
        },
        currency: {
            type: ['string', 'null']
        }
    }
};
